module.exports = __webpack_public_path__ + "static/media/IMPACT_YOUTH_Startin_Point_6-TheDuke.LDN.0586b329.jpg";